import useAuthenticationContext from "../components/authentication/AuthenticationContext"

export const useNickname = () => {
	const { credentialDetails } = useAuthenticationContext()
	return credentialDetails.isAuthenticated ? credentialDetails.name : null
}

export const useUserInitials = () => {
	const { credentialDetails } = useAuthenticationContext()
	return credentialDetails.isAuthenticated ? credentialDetails.initials : null
}
